import React, { Component } from "react";
import FlexView from "react-flexview";
import SimpleModal from "./SimpleModal";
import Api from "../../Services/Api";
import { connect } from "react-redux";
import IdpAction from "../../Redux/IdpRedux";

class ProfileUserProfileModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userProfile: null,
    };
  }

  componentDidMount() {
    Api.create("NAGAMAS_MASTER_DATA")
      .getUserProfile({ idUser: this.props.username })
      .then((res) => {
        if (res.ok) {
          this.setState({ userProfile: res.data.data });
          this.props.getUserSuccess(res.data.data);
        }
      });
  }

  render() {
    const { username, visible, onClickClose } = this.props;

    return (
      <SimpleModal
        title="User Profile"
        visible={visible}
        onClickClose={onClickClose}
        styles={{
          width: "30%",
          minWidth: "30%",
        }}
        content={
          <FlexView column style={{ padding: "1rem 2rem", textAlign: "left", gap: "10px" }}>
            <p>Name: {this.state.userProfile ? this.state.userProfile.name : "null"}</p>
            <p>Role: {this.state.userProfile ? this.state.userProfile.roleName : "example role"}</p>
            <p>
              Hak Akses Cabang: &nbsp;
              {this.state.userProfile && this.state.userProfile.hakAksesCabang
                ? this.state.userProfile.hakAksesCabang.join(", ")
                : ""}
            </p>
            <FlexView style={{ gap: "3rem" }}>
              <p>Level Hirarki:</p>
              <FlexView column={true}>
                <p>Ahass: {this.state.userProfile ? this.state.userProfile.ahassLine : "null"}</p>
                <p>
                  Marketing:{" "}
                  {this.state.userProfile ? this.state.userProfile.marketingLine : "null"}
                </p>
                <p>
                  Admin:{" "}
                  {this.state.userProfile ? this.state.userProfile.administrationLine : "null"}
                </p>
              </FlexView>
            </FlexView>
          </FlexView>
        }
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getUserSuccess: (payload) => dispatch(IdpAction.getUserSuccess(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfileUserProfileModal);
